import { render, staticRenderFns } from "./FactionBuildingCard.vue?vue&type=template&id=3ed5c9cf&"
import script from "./FactionBuildingCard.vue?vue&type=script&lang=js&"
export * from "./FactionBuildingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports